function enableTouch(e) {
    e.Panzoom.options.touch = true;

    const carouselDiv = e.$container;
    carouselDiv.style.cursor = "grab";
}

function disableTouch(e) {
    e.Panzoom.options.touch = false;

    const carouselDiv = e.$container;
    carouselDiv.style.cursor = "default";
}

function setTouch(e) {
    if (window.innerWidth < 1280) {
        enableTouch(e);
    } else {
        disableTouch(e);
    }

    window.addEventListener('resize', function(){
        if (window.innerWidth < 1280) {
            enableTouch(e);
        } else {
            disableTouch(e);
        }
    })        
}